var _path, _path2, _line, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDrinkingWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.38,21.562h9.815v10.882h0c-5.417,0-9.815-4.398-9.815-9.815v-1.067h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.399,15.416c.131-.31.301-.599.505-.86"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m28.812,13.238c.356-.109.735-.168,1.127-.168,2.122,0,3.842,1.72,3.842,3.842v1.056",
    style: {
      strokeDasharray: "0 0 2.35 2.35"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.78,
    y1: 19.139,
    x2: 33.78,
    y2: 20.139
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6.866,
    r: 4.142
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.817,39.276c-1.111,0-2.012-.901-2.012-2.012v-15.756c0-.534.212-1.045.589-1.423l7.668-7.668c.576-.576,1.441-.747,2.193-.436.752.311,1.242,1.045,1.242,1.859v2.206c0,2.335,1.9,4.235,4.235,4.235,1.111,0,2.012.901,2.012,2.012s-.901,2.012-2.012,2.012c-3.749,0-6.923-2.511-7.928-5.94l-3.976,3.976v14.922c0,1.111-.901,2.012-2.012,2.012Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDrinkingWater);
export default __webpack_public_path__ + "static/media/indoor-drinking_water.dfc5d19d059d3b4c0f65250e1c9f56d7.svg";
export { ForwardRef as ReactComponent };